// extracted by mini-css-extract-plugin
module.exports = {"materialUIIcon":"style_materialUIIcon__1sk0x","materialUiIcon":"style_materialUIIcon__1sk0x","imageIcon":"style_imageIcon__264Ki","fontAwesomeIcon":"style_fontAwesomeIcon__wQsIJ"};